import React from "react";
import { Link } from "react-router-dom";
import LegalDoc from "./LegalDoc";
import { title, lastUpdated, markdown } from "../../legal/terms";

export default function Terms() {
    return (
        <LegalDoc
            title={title}
            lastUpdated={lastUpdated}
            markdown={markdown}
            intro={
                <p className="legal__cross">
                    See also the <Link to="/privacy">Privacy Policy</Link>.
                </p>
            }
        />
    );
}
